<h5 mat-dialog-title>Assign Security &mdash; {{ reportName }}</h5>

<mat-dialog-content>
    <p class="assign-security-hint">
        Roles selected below can view this report. Users with the Reports Administrator role always have full access.
    </p>

    <kendo-grid
            class="grid"
            [data]="gridDataResult"
            [loading]="isLoading"
            [style.maxHeight.vh]="60"
            [selectable]="{enabled: true}"
            kendoGridSelectBy="id"
            [(selectedKeys)]="selectedItems"
            [pageSize]="pageSize"
            [skip]="skip"
            [pageable]="{
                info: true,
                pageSizes: [5, 10, 20, 50, 100],
                previousNext: true
            }"
            (pageChange)="pageChange($event)">

        <ng-template kendoGridToolbarTemplate>
            <div class="filters-container">
                <mat-form-field class="search-field" appearance="outline">
                    <input matInput
                           placeholder="Search roles..."
                           [(ngModel)]="searchValue"
                           (input)="search()"
                    >
                    <mat-icon matPrefix class="material-icons-outlined">
                        search
                    </mat-icon>
                </mat-form-field>
            </div>
        </ng-template>

        <kendo-grid-checkbox-column
                [width]="80"
                showSelectAll="true"
        ></kendo-grid-checkbox-column>

        <kendo-grid-column
                *ngFor="let col of columns"
                [field]="col.field"
                [title]="col.title"
        ></kendo-grid-column>

    </kendo-grid>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Cancel</button>

    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()">
        Save ({{selectedItems.length}} selected)
    </button>
</mat-dialog-actions>
